import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ist-application-ext',
  templateUrl: './ist-application-ext.component.html',
  styleUrls: ['./ist-application-ext.component.scss']
})
export class IstApplicationExtComponent implements OnInit {
  

  constructor() { }

  ngOnInit() {
  }

  

}
